<template>
  <!-- 支付二维码 -->
  <div class='qrcode'>
    <div class='content'>
      <h3>二维码支付</h3>
      <div class='img-wrapper'>
        <img src='../assets/imgs/logo_icon.png' alt='' class='logo'>
        <img :src='qrcode' alt='' class='qr-code'>
        <p class='text'>{{ text }}</p>
      </div>
      <a href='javascript:;' class='btn' @click='successPay'>支付完成</a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
    }
  },

  computed: {
    text() {
      return this.$store.state.payQrcode.type === 'ALIPAY' ? '支付宝付款码' : '微信付款码'
    },
    qrcode() {
      return this.$store.state.payQrcode.code
    }
  },

  methods: {
    successPay() {
      this.$emit('successpay')
    }

  }
}
</script>

<style lang="less" scoped>
@import "../assets/css/mixin.less";
.qrcode {
  min-width: 1200px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);

  .content {
    width: 520px;
    height: 465px;
    margin: 150px auto 0;
    background: #ffffff;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    position: relative;

    h3 {
      height: 46px;
      line-height: 46px;
      font-size: 20px;
      color: #ffffff;
      background: @blue-d;
      text-align: center;
      margin-bottom: 30px;
    }

    .img-wrapper {
      width: 230px;
      height: 288px;
      background: @blue-l;
      margin: 0 auto;

      .logo {
        display: block;
        width: 50px;
        height: auto;
        padding: 15px 0;
        margin: 0 auto;
      }
      .qr-code {
        display: block;
        width: 193px;
        height: 193px;
        margin: 0 auto;
        background-color: #ffffff;
      }
      .text {
        text-align: center;
        font-size: 14px;
        color: #000;
        margin-top: 5px;
      }
    }
    .btn {
      display: block;
      width: 230px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      color: #fff;
      background-color: @blue-d;
      margin: 30px auto 0;
      border-radius: 5px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Qrcode.vue